import FiltersV2 from './Filters.v2'

export default FiltersV2
// eslint-disable-next-line import/export
export * from './Filters.v2'
